import React from "react";
import TopBar from "@/components/landing/TopBar";
import Hero from "@/components/landing/Hero";
import { PartnerStrip, StatsBand } from "@/components/landing/Authority";
import BrandWall from "@/components/landing/BrandWall";
import Panic from "@/components/landing/Panic";
import Mistakes from "@/components/landing/Mistakes";
import CostAnalysis from "@/components/landing/CostAnalysis";
import CaseStudies from "@/components/landing/CaseStudies";
import ChannelCaseStudies from "@/components/landing/ChannelCaseStudies";
import Reviews from "@/components/landing/Reviews";
import ThreePaths from "@/components/landing/ThreePaths";
import Process from "@/components/landing/Process";
import Founder from "@/components/landing/Founder";
import Faq from "@/components/landing/Faq";
import FinalCta from "@/components/landing/FinalCta";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative">
      <TopBar />
      <Hero />
      <PartnerStrip />
      <StatsBand />
      <BrandWall />
      <Panic />
      <Mistakes />
      <CostAnalysis />
      <CaseStudies />
      <ChannelCaseStudies />
      <Reviews />
      <ThreePaths />
      <Process />
      <Founder />
      <Faq />
      <FinalCta />
    </main>
  );
}
